// =====================================================================================
// FILE: src/constants/views.js
// =====================================================================================

export const POLL_MS = 6000;
export const TEAM_LIST_VIEW_NAME = "Team List";
export const DEFAULT_NEW_STATUS = "New Submission";

// ✅ DEPRECATED: VIEW_TO_FIXTURE is no longer used - fixture keys are derived dynamically
// from view names using viewNameToFixtureKey() in viewLoader.js
export const VIEW_TO_FIXTURE = {};

// ✅ DEPRECATED: VIEW_LIST is no longer used - views are fetched dynamically from Airtable
export const VIEW_LIST = [];

// ✅ DEFAULT_VIEW is now null - the app will use the first available view from Airtable
// This ensures multi-club deployments work without hardcoded view names
export const DEFAULT_VIEW = null;
